import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_DOCTOR_APPOINTMENTS_PATIENTS } from "../../action-types/actions";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const getDoctorAppointmentsPatientsReducer = createAsyncThunk(
  ACTIONS_DOCTOR_APPOINTMENTS_PATIENTS.get_list,
  async (params, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      // Build query params object, only including defined and non-empty values
      const queryParamsObj = {};

      if (
        params.search &&
        typeof params.search === "string" &&
        params.search.trim()
      ) {
        queryParamsObj.search = params.search.trim();
      }

      if (
        params.status &&
        typeof params.status === "string" &&
        params.status.trim()
      ) {
        queryParamsObj.status = params.status.trim();
      }

      if (
        params.start_date &&
        typeof params.start_date === "string" &&
        params.start_date.trim()
      ) {
        queryParamsObj.start_date = params.start_date.trim();
      }

      // Always include page and limit
      queryParamsObj.page = String(params.page || 1);
      queryParamsObj.limit = String(params.limit || 10);

      const queryParams = new URLSearchParams(queryParamsObj).toString();
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.doctorAppointmentsPatients}${queryParams ? `?${queryParams}` : ""}`;
      const response = await axiosPrivate.get(fullUrl);

      if (response?.status === 200 && response?.data?.status === true) {
        return response.data;
      } else {
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
